import { playsWomensTee, teeGroupsFor } from './players'

// What the placed field is already on, for golfers who arrive after Course & Tee ran. Either
// gender's tee stands in for a missing one: a group with no tee refuses to open for scoring.
export const teesFromSheet = (foursomes) => {
  const placed = foursomes.flatMap((group) => group.attributes?.players || [])
  const womensTee = placed.find((player) => playsWomensTee(player))?.tee?.id
  const mensTee = placed.find((player) => !playsWomensTee(player))?.tee?.id
  const hole = foursomes.find((group) => group.attributes?.hole)?.attributes?.hole

  return {
    menTee: mensTee || womensTee || '',
    womenTee: womensTee || mensTee || '',
    hole: hole || null,
  }
}

// A walk-on event still needs a sheet -- the group mints a golfer's GGID pin -- and v3 has no
// placement endpoint. Only unplaced golfers are dealt in, so a halted run resumes on a second call.
export const placeWalkonField = async ({
  round: { leagueId, roundId },
  field: { unplaced, foursomes },
  tees: { menTee, womenTee, holesType, hole },
  api: { createRow, setCourseAndTee, setHole, refetchTeeSheet },
  onError,
}) => {
  if (unplaced.length === 0) { return true }
  if (!menTee) { onError(); return false }

  const { order, groups } = teeGroupsFor(unplaced, { menTee, womenTee })
  const knownGroupIds = new Set(foursomes.map((group) => group.id))

  for (const playerRoundId of order) {
    // eslint-disable-next-line no-await-in-loop
    const created = await createRow({ leagueId, roundId, playerIds: [ playerRoundId ], silent: true })
    if (created.error) { onError(); return false }
  }

  for (const [ teeForGroup, playerIds ] of groups) {
    if (playerIds.length === 0) { continue }
    // eslint-disable-next-line no-await-in-loop
    const teed = await setCourseAndTee({
      leagueId,
      roundId,
      teeId: teeForGroup,
      playerIds,
      ...(holesType ? { holesType } : {}),
      silent: true,
    })
    if (teed.error) { onError(); return false }
  }

  // create_row does not echo the row it made, so the new groups are whatever the refetch adds.
  const { data } = await refetchTeeSheet()
  const newGroupIds = (data?.data || []).map((group) => group.id).filter((id) => !knownGroupIds.has(id))
  // No hole means nothing was on the sheet to copy one from -- the first placement supplies its own.
  if (newGroupIds.length === 0 || !hole) { return true }

  const holed = await setHole({ leagueId, roundId, hole, foursomeIds: newGroupIds, silent: true })
  if (holed.error) { onError(); return false }
  return true
}
